import { render, staticRenderFns } from "./logoModal.vue?vue&type=template&id=c4cbe3f6&scoped=true"
import script from "./logoModal.vue?vue&type=script&lang=ts"
export * from "./logoModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4cbe3f6",
  null
  
)

export default component.exports